import Checklist from '__core/shared/model/checklist/Checklist';
import ChecklistItem from '__core/shared/model/checklist/ChecklistItem';
import stChecklistAdd from './checklistAdd.component';
import stChecklistEdit from './checklistEdit.component';
import stChecklistItemList from './checklistItemList.component';
import stChecklistItemsList from './checklistItemsList.component';
import checklistsController from './checklists.controller';
import stChecklistsList from './checklistsList.component';

export default angular
  .module('st.Checklist', ['st.Core', 'angular-cache'])
  .factory('Checklist', () => Checklist)
  .factory('ChecklistItem', () => ChecklistItem)
  .component('stChecklistAdd', stChecklistAdd)
  .component('stChecklistEdit', stChecklistEdit)
  .component('stChecklistItemList', stChecklistItemList)
  .component('stChecklistItemsList', stChecklistItemsList)
  .controller('checklistsController', checklistsController)
  .component('stChecklistsList', stChecklistsList)
  .service('checklistService', (Checklist, dataService) => ({
    createChecklist: (doc) => dataService.createDocument(Checklist, doc),
    readChecklist: (doc) => dataService.readDocument(Checklist, doc),
    updateChecklist: (doc) => dataService.updateDocument(Checklist, doc),
    deleteChecklist: (doc) => dataService.deleteDocument(Checklist, doc)
  }))
  .service(
    'checklistsService',
    ($http, $rootScope, CacheFactory, dataService, Checklist, CHECKLIST) => {
      let cache;
      if (!CacheFactory.get(CHECKLIST.CACHE.NAME)) {
        cache = CacheFactory(CHECKLIST.CACHE.NAME, CHECKLIST.CACHE.STORE);
      }
      const cacheKey = (params, requestName) =>
        JSON.stringify({
          idAccount: $rootScope.CurrentAccount.id,
          idOrganization: $rootScope.CurrentOrganization.id,
          type: requestName || CHECKLIST.CACHE.NAME,
          params
        });
      return {
        clearCache: () => cache.removeAll(),
        getAvailable: (params) =>
          dataService.apiRequest(
            cache,
            cacheKey(params),
            params?.ignoreCache === true,
            Checklist.build,
            $http.get,
            CHECKLIST.API.AVAILABLE,
            { params }
          )
      };
    }
  )
  .constant('CHECKLIST', {
    API: {
      AVAILABLE: '/api/v1/checklists/available/'
    },
    CACHE: {
      NAME: 'checklistsCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
